import { useRecordHistory } from "misc/customHooks";
import { RecordHistoryRecordType } from "organisms/RecordHistory/RecordHistory.types";
import { createContext, ReactNode } from "react";
import { Identifier } from "react-admin";

type RecordHistoryContextType = {
  data: RecordHistoryRecordType[];
  isLoading: boolean;
  refetchHistory: () => Promise<unknown>;
};

const defaultRecordHistoryContextValue = {
  data: [],
  isLoading: false,
  refetchHistory: () => Promise.resolve(undefined),
};

export const RecordHistoryContext = createContext<RecordHistoryContextType>(defaultRecordHistoryContextValue);
export const ParentRecordHistoryContext = createContext<RecordHistoryContextType>(defaultRecordHistoryContextValue);

type RecordHistoryContextProviderPropsType = {
  id: Identifier;
  resource: string;
  children: ReactNode;
};

export default function RecordHistoryContextProvider(props: RecordHistoryContextProviderPropsType) {
  const { children, id, resource } = props;

  const recordHistoryContextValue = useRecordHistory(resource, id);

  return <RecordHistoryContext.Provider value={recordHistoryContextValue}>{children}</RecordHistoryContext.Provider>;
}
